<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3018,12.4331l0.0908,0.3677l0.3789,0.0117
      c0.2974,0.0095,0.5818,0.0594,0.8574,0.1309c1.8618-0.4913,3.3795-1.8293,4.0901-3.5908
      c-0.4448,0.1034-0.9082,0.1583-1.3844,0.1583c-3.3574,0-6.0792-2.7217-6.0792-6.0792c0-0.8036,0.156-1.571,0.4392-2.2733
      C13.0043,1.785,11,4.1981,11,7.0791c0,0.1427,0.0117,0.2824,0.0214,0.4227C14.0034,7.5117,16.5847,9.5358,17.3018,12.4331z"/>
    <path d="M10.9998,8.0002c2.7609,0,5.1527,1.8724,5.8164,4.5533l0.182,0.7351l0.757,0.024
      c1.8195,0.0577,3.2446,1.5237,3.2446,3.3376c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2406,0-2.25-1.0094-2.25-2.2501
      c0-0.921,0.5547-1.7391,1.4131-2.0842l0.6992-0.2811l-0.0775-0.7496c-0.0234-0.2259-0.0348-0.4337-0.0348-0.6351
      C4.9998,10.6919,7.6914,8.0002,10.9998,8.0002 M10.9998,7.0002c-3.866,0-7,3.1331-7,7.0001c0,0.2501,0.015,0.496,0.04,0.738
      c-1.194,0.48-2.04,1.6451-2.04,3.012c0,1.794,1.4551,3.2501,3.25,3.2501h12.4c2.403,0,4.35-1.9481,4.35-4.35
      c0-2.3561-1.875-4.263-4.2129-4.3372C17.0317,9.2633,14.2838,7.0002,10.9998,7.0002L10.9998,7.0002z"/>
  </g>
</template>

<script>
export default {
  name: 'MostlyClearNight'
}
</script>